import { OptionTypes, ConditionValuesOperator, FilterTypes } from 'app/components/filters/types';
import { FavouriteConditionValue } from 'app/types-shared';

export const createInitialDecimalFieldConditions = (favouriteConditionValue: FavouriteConditionValue,
  conditionValues: FavouriteConditionValue[]) => {

  if (favouriteConditionValue.operator && favouriteConditionValue.operator.v === ConditionValuesOperator.empty) {
    return {
      [FilterTypes.DecimalNumber]: { type: OptionTypes.NotSpecified }
    };
  }

  return {
    [FilterTypes.DecimalNumber]: { type: OptionTypes.SpecificNumbersOrRanges, value: favouriteConditionValue.number, 
      value2: favouriteConditionValue.number2 }
  };
};
